<div
  class="fdx-c-form-group fdx-c-form-group--float-label fdx-c-form-group--has-value"
  [ngClass]="{
    'fdx-c-form-group--is-invalid': isControlTouchedAndInvalid(formField),
  }">
  <span class="fdx-c-form-group__item">
    <ng-content></ng-content>
    @if (labelName) {
      <label
        class="fdx-c-form-group__label fdx-c-form-group__label--dark fdx-u-px--4"
        >{{ labelName }}</label
      >
    }
    @if (suffix) {
      <span class="fdx-c-form-group__suffix" style="margin-right: 5px">{{
        suffix
      }}</span>
    }
  </span>

  <app-form-field-error-messages [formField]="formField">
  </app-form-field-error-messages>
</div>
